import { render, staticRenderFns } from "./BottomPanel.vue?vue&type=template&id=9b8e570c&scoped=true&"
import script from "./BottomPanel.vue?vue&type=script&lang=ts&"
export * from "./BottomPanel.vue?vue&type=script&lang=ts&"
import style0 from "./BottomPanel.vue?vue&type=style&index=0&id=9b8e570c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8e570c",
  null
  
)

component.options.__file = "BottomPanel.vue"
export default component.exports